import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { EmailStatus } from './email.status.enum';
import { UserRole } from '@40seas/entities/users';

export enum EmailProviderType {
    Sendgrid = 'sendgrid',
}

export const EmailSchema = WithBaseEntitySchema(
    z.object({
        from: z.string().email().optional(),
        to: z.array(z.string().email()).optional(),
        cc: z.array(z.string().email()).optional(),
        inbox: z.string().email().optional(),
        subject: z.string().optional(),
        body: z.string().optional(),
        status: EnumSchema(EmailStatus),
        entityType: z.string().optional(),
        emailParams: z.record(z.unknown()).optional(),
        entityId: z.string().optional(),
        templateId: z.string().optional(),
        providerId: z.string().optional(),
        providerType: EnumSchema(EmailProviderType).optional(),
        role: EnumSchema(UserRole).optional(),
    }),
).strict();

export class Email extends FromSchema(EmailSchema) implements BaseEntity {
    id: string;
    from?: string;
    to?: string[];
    cc?: string[];
    role?: UserRole;
    inbox?: string;
    subject?: string;
    body?: string;
    status: EmailStatus;
    emailParams?: { [key: string]: unknown };
    entityType?: string;
    entityId?: string;
    templateId?: string;
    providerId?: string;
    providerType?: EmailProviderType;
    seller: string | Seller;
    createdAt: Date;
    updatedAt: Date;
    createdBy?: Executor;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
